import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { OutcomeBadge, LinkBadge, money, offerLabel } from "./Badges";

function Candidate({ c, offer, onDecide, busy }) {
  const undecided = offer.link.status === "none" || offer.link.status === "rejected";
  return (
    <div className="border rounded-lg p-2 text-xs flex items-start justify-between gap-3" data-testid={`oc-candidate-${offer.key}-${c.legacy_id}`}>
      <div>
        <div className="font-semibold">TedOps {c.legacy_id} · {c.title}</div>
        <ul className="text-slate-500 mt-0.5 list-disc ml-4">{c.evidence.map((e) => <li key={e}>{e}</li>)}</ul>
      </div>
      {undecided && offer.match.outcome !== "no_match" && (
        <Button size="sm" disabled={busy} onClick={() => onDecide("approve", c.legacy_id)} data-testid={`oc-approve-${offer.key}-${c.legacy_id}`}>Approve link</Button>
      )}
    </div>
  );
}

export function OfferDecision({ wcId, offer, onChange }) {
  const [busy, setBusy] = useState(false);
  const decide = async (action, lid) => {
    setBusy(true);
    try {
      const r = await api.post(`/online-catalogue/items/${wcId}/decide`, { action, wc_variation_id: offer.wc_variation_id, tedops_legacy_id: lid || null });
      onChange(r.data); toast.success("Decision recorded");
    } catch (x) { toast.error(x.response?.data?.detail || "Action failed"); }
    setBusy(false);
  };
  const st = offer.link.status;
  return (
    <div className="rounded-xl border bg-white p-3 space-y-2" data-testid={`oc-offer-${offer.key}`}>
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <span className="font-medium">{offerLabel(offer)}</span>
        <OutcomeBadge m={offer.match} testId={`oc-offer-outcome-${offer.key}`} />
        <LinkBadge link={offer.link} testId={`oc-offer-link-${offer.key}`} />
        <span className="text-xs text-slate-500 ml-auto">{money(offer.price_inc_vat)} inc VAT · {offer.stock_status}{offer.stock_quantity != null ? ` (${offer.stock_quantity})` : ""} · GTIN {offer.gtin || "—"}</span>
      </div>
      {offer.match.reason && <p className="text-xs text-amber-800">{offer.match.reason}</p>}
      {offer.match.candidates.map((c) => <Candidate key={c.legacy_id} c={c} offer={offer} onDecide={decide} busy={busy} />)}
      <div className="flex gap-2">
        {st === "none" && offer.match.outcome !== "no_match" && <Button size="sm" variant="outline" disabled={busy} onClick={() => decide("reject")} data-testid={`oc-reject-${offer.key}`}>Reject match</Button>}
        {(offer.match.outcome === "no_match" && st === "none") || st === "rejected" ? <Button size="sm" variant="outline" disabled={busy} onClick={() => decide("create_new")} data-testid={`oc-create-${offer.key}`}>Create catalogue item</Button> : null}
        {st !== "none" && <Button size="sm" variant="ghost" disabled={busy} onClick={() => decide("reset")} data-testid={`oc-reset-${offer.key}`}>Reset decision</Button>}
      </div>
    </div>
  );
}
